<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TlbsText',
  
})
</script>
<template>
  <p
    class="tlbs-text"
  >
    {{ text }}
  </p>
</template>

<script setup lang="ts" name="TlbsText">
interface Props {
  text: string;
}

withDefaults(defineProps<Props>(), {
  text: '',
});
</script>
